import { Component, OnInit, Input } from '@angular/core';
import { TopBox } from '../../../store';

@Component({
  selector: 'app-top-boxes',
  templateUrl: './top-boxes.component.html',
  styleUrls: ['./top-boxes.component.css']
})
export class TopBoxesComponent implements OnInit {

  @Input() contents: TopBox[];
  @Input() activeBox: string;

  constructor() { }

  ngOnInit() {
  }

  get visibleContents() {
    return this.contents && this.contents.filter(c => !c.hide) || [];
  }

  get blockClass(): string {
    return this.visibleContents.length === 3 ? 'col-sm-4 col-lg-4' :
      this.visibleContents.length === 4 ? 'col-sm-3 col-lg-3' : 'col-sm-6 col-lg-6';
  }

  onClick(event: Event, x) {
    event.stopPropagation();
    x.onClick();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/top-boxes/top-boxes.component.ts